// extracted by mini-css-extract-plugin
export var Share = "Share-module--Share--YGaZ0";
export var aniSpin = "Share-module--ani-spin--R5oQ4";
export var list = "Share-module--list--Hr-HW";
export var list__item = "Share-module--list__item--BqUnc";